// What to call a client or supplier on screen. In the code they are
// "partners"; admins see "Clients & Suppliers", and buttons and titles name
// the role in view.

// The noun for a role filter: "client", "supplier", or "" for all.
export function roleNoun(role) {
  if (role === "client") return "Client";
  if (role === "supplier") return "Supplier";
  return "";
}

// "Add Client", "Add Supplier", or just "Add" when the view shows both.
export function withRole(verb, role) {
  const noun = roleNoun(role);
  return noun ? `${verb} ${noun}` : verb;
}

// A partner's own roles as a title: "Client", "Supplier" or "Client & Supplier".
export function rolesTitle(roles) {
  const list = roles || [];
  if (list.includes("client") && list.includes("supplier")) return "Client & Supplier";
  if (list.includes("supplier")) return "Supplier";
  if (list.includes("client")) return "Client";
  return "Client or Supplier";
}
